import { ELPLAN_REFRESH_EVENT_QUERY_KEY } from 'api/elplan/elplan.constants'
import elplanStore from 'store/elplan/elplan'
import { Card } from 'ui/atoms'
import UiConfig from 'ui/uiConfig/UiConfig'
import { useSnapshot } from 'valtio'
import { DatepickerInFormWithSwitch } from '../DatepickerInFormWithSwitch'
import { DayOptions } from '../types'
import styles from './UIConfigWithDatepicker.module.less'

type UIConfigWithDatepickerProps = { type: string; title: string; defaultDay: DayOptions }

export function UIConfigWithDatepicker({ type, title, defaultDay }: UIConfigWithDatepickerProps) {
  const elplanSnap = useSnapshot(elplanStore)

  return (
    <Card title={title}>
      <div className={styles.UIConfigWithDatepicker_Period}>
        <DatepickerInFormWithSwitch defaultDay={defaultDay} />
      </div>
      <div className={styles.UIConfigWithDatepicker_Tables}>
        <UiConfig
          type={type}
          datasetStartTime={elplanSnap.date.start_time}
          datasetEndTime={elplanSnap.date.end_time}
          datasetRefreshToken={ELPLAN_REFRESH_EVENT_QUERY_KEY}
        />
      </div>
    </Card>
  )
}
